import iconProductDesign from '../assets/icons/icon_product_design.svg'
import iconCode from '../assets/icons/icon_code.svg'
import iconUserExperience from '../assets/icons/icon_user_experience.svg'
import iconUserInterface from '../assets/icons/icon_user_interface.svg'
import iconPrototype from '../assets/icons/icon_prototype.svg'
import iconProductStrategy from '../assets/icons/icon_product_stratetgy.svg'
import iconTerminalCode from '../assets/icons/icon_terminal_code.svg'
import iconDesignSystems from '../assets/icons/icon_design_systems.svg'

export const skillTags = [
  { label: 'Product Design',        icon: iconProductDesign },
  { label: 'User Interfaces',       icon: iconUserInterface },
  { label: 'User Experiences',      icon: iconUserExperience },
  { label: 'Product strategy',      icon: iconProductStrategy },
  { label: 'Prototypes',            icon: iconPrototype },
  { label: 'Coding',                icon: iconCode },
  { label: 'AI-assisted workflows', icon: iconTerminalCode },
  { label: 'AI Design systems',     icon: iconDesignSystems }
]
